import { Link } from 'react-router-dom';
import cn from 'classnames';
import { iButtonCarouselItemComponent } from '../../interface/iProviders';
import { isValidUrl } from '@intigral/utils';
import { FontIcon, Text } from '@intigral/shared';
import styles from './button-carousel.module.sass';

export const ListItem = ({ item, itemClickCallback, textOnly = false }: iButtonCarouselItemComponent) => {
    const { url, linkState, title, imageLink, locked } = item;
    const isExternal = isValidUrl(url); // item.url.toLowerCase().startsWith('http://') || item.url.toLowerCase().startsWith('https://');
    return (
        <Link
            to={url}
            className={cn(item.class ? ` ${item.class}` : '', styles.card)}
            onClick={(e) => {
                if (typeof itemClickCallback === 'function') {
                    itemClickCallback(item, e);
                }
            }}
            target={isExternal ? '_blank' : '_self'}
            rel={isExternal ? 'noopener noreferrer nofollow' : ''}
            state={linkState || {}}
            id={item?.id}
            data-test-id={item?.id}
            {...(imageLink && { style: { backgroundImage: `url(${imageLink})` } })}
        >
            {/* {textOnly ? ( */}
            <Text as="span" variant="text1" color="white">
                {title}
            </Text>
            {locked && <FontIcon name="lock" color="orange" md="x-small" className={styles['lock-icon']} />}
        </Link>
    );
};
